<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <h2>Acciones</h2>
            <ul class="contenedoraplicaciones">
                <li @click="tipoDocumento('almacenar'); $router.push('/selectinput')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/archivo.png" width="70%" />
                        </div>
                        <p>Enviar documento</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Envía un documento a toda la empresa o a centros o usuarios
                        específicos sin necesidad de confirmar su lectura ni de firmarlo.</span>
                </li>
                <li @click="tipoDocumento('firmar'); $router.push('/selectdocuments')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/firma.png" width="70%" />
                        </div>
                        <p>Enviar con firma</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Envía documentos a firmar a los usuarios que selecciones de forma masiva.</span>
                </li>
                <li @click="tipoDocumento('nominas'); $router.push('/selectdocuments')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/nomina.png" width="70%" />
                        </div>
                        <p>Subir nóminas</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Carga todas las nóminas a la vez y envía a cada usuario su nómina individualmente.</span>
                </li>
                <!-- <li @click="tipoDocumento('almacenar'); $router.push('/selectinput'); configEnvio.seguimiento = 1" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/notificacion.png" width="70%" />
                        </div>
                        <p>Enviar con seguimiento</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Envía documentos y haz un seguimiento de lectura para asegurarte de que nadie se pierde nada.</span>
                </li> -->
            </ul>
            <h2>Consultas</h2>
            <ul class="contenedoraplicaciones">
                <li @click="$router.push('/posts')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/redes-sociales.png" width="70%" />
                        </div>
                        <p>Mis publicaciones</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Revisa el listado de publicaciones para gestionarlas.</span>
                </li>
                <li @click="$router.push('/sentdocuments')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/seguimiento.png" width="70%" />
                        </div>
                        <p>Panel de firmas</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Consulta todos los movimientos y verifica su estado.</span>
                </li>
                <li @click="$router.push('/userdocuments')" class="tipodocumento">
                    <div style="display:flex">
                        <div class="icono">
                            <img src="@/assets/carpetapersonal.png" width="70%" />
                        </div>
                        <p>Documentos de los usuarios</p>
                    </div>
                    <hr style="border:none">
                    <span style="font-weight:normal">Accede a las carpetas de documentos de los usuarios.</span>
                </li>
            </ul>
        </div>
    </el-col>
</template>

<script>
// import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'MisBuzones',
    watch: {
    },
    data() {
        return {
            loading: false,
            router: this.$router,
            working: process.env.VUE_APP_WORKING,
        }
    },
    mounted() {
        this.setConfigEnvio({});
        this.setContent('');
        this.setPubTitulo('');
        if(this.working == 'firmas') {
            if(this.datosemp && this.datosemp.token) {
            this.tipoDocumento('firmar'); 
            this.$router.push('/selectdocuments');
            } else {
                this.$router.push('/login');
            }
        }
        if(this.params.get('accion') == 'firmar') {
            this.tipoDocumento('firmar'); 
            this.$router.push('/selectdocuments');
        }
        if(this.params.get('accion') == 'publicar') {
            this.tipoDocumento('almacenar'); 
            this.$router.push('/selectinput');
        }
        this.listReset();
    },
    computed: mapState([
        'datosemp', 'receptores', 'configEnvio', 'params'
    ]),
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setConfigEnvio',
            'setContent',
            'setPubTitulo'
        ]),
        tipoDocumento(accion) {
            this.setConfigEnvio({accion});
        },
        actualizarReceptores() {
            // Definir el orden de los tipos
            var ordenTipos = [
                "empresa",
                "área",
                "centro",
                "departamento",
                "empleado",
            ];
            // Ordenar el array
            // this.receptores.sort(function (a, b) {
            //   return a.localeCompare(b);
            // })
            if (this.working == 'documentos') {
                this.receptores.sort(function (a, b) {
                    if (a.selected && !b.selected) {
                        return -1; // a viene antes que b (a es selected y b no)
                    } else if (!a.selected && b.selected) {
                        return 1; // b viene antes que a (b es selected y a no)
                    } else if (a.disabled && !b.disabled) {
                        return 1; // b viene antes que a (a es disabled y b no)
                    } else if (!a.disabled && b.disabled) {
                        return -1; // a viene antes que b (b es disabled y a no)
                    } else {
                        // Si tienen el mismo valor para "selected" y "disabled", ordenar por "tipo" y luego por "id"
                        var tipoA = ordenTipos.indexOf(a.tipo);
                        var tipoB = ordenTipos.indexOf(b.tipo);
                        if (tipoA !== tipoB) {
                            return tipoA - tipoB; // Ordenar por "tipo" según el orden definido en "ordenTipos"
                        } else if (a.nombre != null && b.nombre != null) {
                            return a.nombre.localeCompare(b.nombre); // Ordenar por "id" en orden ascendente
                        }
                    }
                });
            }
            this.uploadData = {
                receptores: JSON.stringify(this.receptores),
            };
            this.numSeleccion = {
                empresas: 0,
                areas: 0,
                centros: 0,
                departamentos: 0,
                empleados: 0,
                total: 0,
            };
            let receptores = this.receptores.filter(function (receptor) {
                return receptor.selected;
            });
            receptores.forEach((receptor) => {
                switch (receptor.tipo) {
                    case "empresa":
                        this.numSeleccion.empresas++;
                        break;
                    case "área":
                        this.numSeleccion.areas++;
                        break;
                    case "centro":
                        this.numSeleccion.centros++;
                        break;
                    case "departamento":
                        this.numSeleccion.departamentos++;
                        break;
                    case "empleado":
                        this.numSeleccion.empleados++;
                        break;
                }
                this.documentos.forEach((doc) => {
                    doc.firmantes = [];
                });
            });
            this.numSeleccion.total =
                this.numSeleccion.empresas +
                this.numSeleccion.areas +
                this.numSeleccion.centros +
                this.numSeleccion.departamentos +
                this.numSeleccion.empleados;
        },
        actualizarLista(receptor) {
            let areas = this.receptores.filter(function (area) {
                return area.tipo == "área" && area.empresa_id == receptor.id;
            });
            let centros = this.receptores.filter(function (centro) {
                return centro.tipo == "centro" && centro.area_id == receptor.id;
            });
            let empleados = this.receptores.filter(function (empleado) {
                return empleado.tipo == "empleado" && empleado.centro_id == receptor.id;
            });
            switch (receptor.tipo) {
                case "empresa":
                    areas.forEach((area) => {
                        area.selected = false;
                        area.disabled = receptor.selected;
                        this.actualizarLista(area);
                    });
                    break;
                case "área":
                    centros.forEach((centro) => {
                        centro.selected = false;
                        centro.disabled = receptor.disabled - receptor.selected;
                        this.actualizarLista(centro);
                    });
                    break;
                case "centro":
                    empleados.forEach((empleado) => {
                        empleado.selected = false;
                        empleado.disabled = receptor.disabled - receptor.selected;
                    });
                    break;
            }
            this.actualizarReceptores();
        },
        listReset() {
            this.receptores.forEach((receptor) => {
                receptor.selected = false;
                receptor.disabled = false;
            });
            this.actualizarReceptores();
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }

    .contenedoraplicaciones {
        width: calc(100% - 5px);
        list-style: none;
        padding-inline-start: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 2.5px;

        @media(max-width: 1500px) {
            flex-direction: column;
        }

        li {
            @media(max-width: 1500px) {
                flex-basis: calc(50% - 20px);
            }

            @media(min-width: 1500px) {
                flex-basis: calc(33% - 20px);
                aspect-ratio: 3/1;
            }

            /* Ajusta este valor según tus necesidades */
            box-sizing: border-box;

            div {
                display: flex;
                align-items: center;
                text-align: left;
            }

            p {
                margin: 0px;
            }
        }
    }


    .tipodocumento {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 10px;
        border: 2px solid #a9a9a929;
        margin-bottom: 10px;
        border-radius: 10px;
        font-weight: bold;
        transition: 0.5s;
        justify-content: flex-start;

        &:hover {
            background-color: #a9a9a929;
            border-color: #a9a9a929;
        }

        .icono {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #0985e325;
            border-radius: 10px;
            margin-right: 10px;
        }

        .iconoconsulta {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #1abc9c;
            border-radius: 10px;
            margin-right: 10px;
        }
    }
}
</style>